import { useTranslation } from 'react-i18next'
import { AddRegion } from '~/features/common/Taxipark/Regions/AddRegion'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'regions', link: '/taxipark/regions' },
  { titleI18n: 'create region' },
]

export const AddRegionPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('create region')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create region')}</PageTitle>
      </Container>
      <AddRegion />
    </PageContainer>
  )
}
